import { getMethod, postMethod } from '@/services/apis/http-server';

export const getTags = async (params: any) => {
  try {
    const response = await getMethod('client/tags', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};

export const getChartTop = async (params: any) => {
  try {
    const response = await getMethod('client/tags/chart-top', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};

export const registerAPI = async (params: Record<string, string>) => {
  try {
    const response = await postMethod('public/register/api', params);
    return response;
  } catch (error) {
    console.error('Error fetching data from getHomeTags: ', error);
  }
};
